import { connect } from 'react-redux';

import { selectors } from 'dux/createInstance';
import StepThree from './StepThree';

function mapStateToProps(state) {
  return {
    myip: selectors.getCreateInstanceState(state).myip,
    availableAclKinds: selectors.availableACLKindsSelector(state),
    selectedService: selectors.selectedServiceSelector(state),
    selectedCidr: selectors.selectedCidrSelector(state),
  };
}

export default connect(mapStateToProps)(StepThree);
